import { render, staticRenderFns } from "./profile.vue?vue&type=template&id=58a18bb8&scoped=true&"
import script from "./profile.vue?vue&type=script&lang=js&"
export * from "./profile.vue?vue&type=script&lang=js&"
import style0 from "./profile.vue?vue&type=style&index=0&id=58a18bb8&prod&lang=less&"
import style1 from "./profile.vue?vue&type=style&index=1&id=58a18bb8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a18bb8",
  null
  
)

export default component.exports